export default {
    methods: {
        showMessage(title, message, type) {
            if (message instanceof Error) {
                message = message?.response?.data?.errorMessage || this.$t('Msg.sError');
                type = 'error';
            }

            this.$bvToast.toast(message, {
                title: title,
                solid: true,
                variant:
                    type == 'error' || type == 'errorAutoHide'
                        ? 'danger'
                        : type == 'warning'
                        ? 'warning'
                        : type == 'info'
                        ? 'info'
                        : 'success',
                autoHideDelay: 10000
                // noAutoHide: type == 'error' ? true : false
            });
        },

        showPermissionMessage() {
            this.$bvToast.toast(this.$t('DBFunctions.mNotAllowed'), {
                title: this.$t('Msg.Permissions'),
                solid: true,
                variant: 'danger',
                noAutoHide: true
            });
        },

        showWarningMessage(message, link) {
            this.$bvToast.toast(message, {
                title: 'Warning',
                solid: true,
                variant: 'warning',
                to: link,
                noAutoHide: true
            });
        },

        showResponseErrorMessage(error) {
            if (!error || !error.response) {
                console.error(error);
                const msg = this.$t('Msg.retrieveInfo');
                this.showMessage(this.$tc('Msg.Error'), msg, 'error');
                return msg;
            }

            const { status, data, statusText } = error.response;
            const apiMessage =
                data?.errorMessage ||
                data?.message ||
                statusText ||
                this.$t('Msg.ThereWereSomeError');

            const handlers = {
                400: () => apiMessage,
                401: () => this.$t('Msg.Unauthorized'),
                403: () => this.$t('Msg.Forbidden'),
                404: () => apiMessage || this.$t('Msg.NotFound'),
                405: () => {
                    this.$router.push({ name: 'AccessDenied' });
                    return apiMessage;
                },
                409: () => apiMessage,
                422: () => apiMessage,
                500: () => apiMessage
            };

            const finalMessage = handlers[status] ? handlers[status]() : apiMessage;
            this.showMessage(this.$tc('Msg.Error'), finalMessage, 'error');

            return finalMessage;
        }
    }
};
